import React, { FC, useState, useEffect } from 'react';

import { Document } from 'src/common/interfaces/document.interface';
import { DocumentEditor } from 'src/document-editor/document-editor';

interface StepEditorDocumentEditorProps {
  existingDocument: Document;
  onBack: () => void;
  onDocumentUpdate: (document: Document) => void;
}

export const StepEditorContentDocumentEditor: FC<StepEditorDocumentEditorProps> = ({
  existingDocument,
  onBack,
  onDocumentUpdate,
}) => {
  return <DocumentEditor existingDocument={existingDocument} onBack={onBack} onDocumentUpdate={onDocumentUpdate} />;
};
